export const PORTVILLE_ROOMS_SCROLL_KEY = 'portville-scroll-position';
export const PORTVILLE_ROOMS_LAST_SCROLL_KEY = 'portville-rooms:last-scroll-top';
export const PORTVILLE_ROOMS_BEFORE_FORM_SCROLL_KEY = 'portville-rooms:before-form-scroll-top';
export const PORTVILLE_ROOMS_RESTORE_ON_NEXT_KEY = 'portville-rooms:restore-on-next';

export function markPortvilleRoomsRestoreOnNext() {
  if (typeof sessionStorage === 'undefined') return;
  sessionStorage.setItem(PORTVILLE_ROOMS_RESTORE_ON_NEXT_KEY, '1');
}

